module.exports = {
        srcSet: __webpack_public_path__ + "150fac19a2ab07e2-600.webp"+" 600w"+","+__webpack_public_path__ + "1c81d82e8de483e4-1000.webp"+" 1000w",
        images: [{path: __webpack_public_path__ + "150fac19a2ab07e2-600.webp",width: 600,height: 400},{path: __webpack_public_path__ + "1c81d82e8de483e4-1000.webp",width: 1000,height: 667}],
        src: __webpack_public_path__ + "1c81d82e8de483e4-1000.webp",
        toString: function(){return __webpack_public_path__ + "1c81d82e8de483e4-1000.webp"},
        
        width: 1000,
        height: 667
      }